export enum DmAddUserErrorEnum {
  USER_ALREADY_EXISTS_AT_DANCE_MANAGER = 'USER_ALREADY_EXISTS_AT_DANCE_MANAGER',
  USER_INVITE_TOKEN_EXPIRED = 'USER_INVITE_TOKEN_EXPIRED',
  USER_INVITE_TOKEN_NOT_FOUND = 'USER_INVITE_TOKEN_NOT_FOUND',
  USER_INVITE_ALREADY_EXISTS = 'USER_INVITE_ALREADY_EXISTS',
}
